import { createModel, RematchDispatch } from '@rematch/core';
import * as mediaService from '../../services/media.service';
import { Media, PaginationType } from '../../types/CommonTypes';
import { RootModel } from '../models';

import baseEntity from './base.entity';

export const storeName = 'mediaEntity';

export const mediaEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof mediaEntity>) => ({
    async loadById(id, state): Promise<Media> {
      try {
        const { data } = await mediaService.getMedia(id);
        this.saves([data]);
        return data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async load(params): Promise<{ content?: Media[] } & PaginationType> {
      try {
        const res = await mediaService.getMedias(params);
        const { content } = res.data;
        if (content && content.length) {
          this.saves(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async delete(payload) {
      try {
        await mediaService.deleteMedia(payload);
        this.remove(payload);
      } catch (e) {
        throw new Error(e);
      }
    },
    async create(payload) {
      try {
        const { data: item } = await mediaService.createMedia(payload);
        this.saves([item]);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
    async update(payload) {
      try {
        const { data: item } = await mediaService.updateMedia(payload.id, payload);
        this.saves([item]);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default mediaEntity;
